import { Component, EventEmitter, Output, TemplateRef, ViewChild } from '@angular/core';
import { CalendarMonthViewComponent } from 'angular-calendar';
import { DropEvent } from 'angular-draggable-droppable';
import { MonthViewDay } from 'calendar-utils';

@Component({
  selector: 'custom-month-view',
  templateUrl: './custom-month-view.component.html',
  styleUrls: ['./custom-month-view.component.scss'],

  standalone: false
})
export class CustomMonthView extends CalendarMonthViewComponent {
  @Output() public fileDrop = new EventEmitter<{ day: MonthViewDay, files: FileList }>();
  @ViewChild('eventActions', { static: true })
  eventActions!: TemplateRef<any>;

  onDragover(event: DragEvent) {
    if (event.dataTransfer) {
      event.preventDefault();
    }
  }

  onDrop(event: DropEvent<any> | DragEvent, day: MonthViewDay) {
    if (event instanceof DragEvent) {
      if (event.dataTransfer) {
        this.fileDrop.next({ day, files: event.dataTransfer.files });
        event.preventDefault();
      }
    } else {
      this.eventDropped(day, event.dropData.event, event.dropData.draggedFrom);
    }
  }
}  